export default function(val, digits = 2) {
    return isNaN(val) ? '' : Number(val).toLocaleString('pt-BR', { minimumFractionDigits: digits,  maximumFractionDigits: digits})
};